import type { RegionColor } from '@/map/regionColors'

/*
 * Each region color as the utilities that paint it. Written out whole,
 * because Tailwind only generates a class it finds spelled out in the
 * source (see "Species are configured, their marks are not" in
 * docs/field-survey.md).
 */

/** An outline in the color, for a Leaflet path's `className`. */
export const REGION_STROKE: Record<RegionColor, string> = {
  yellow: 'stroke-map-region-yellow',
  cyan: 'stroke-map-region-cyan',
  pink: 'stroke-map-region-pink',
  lime: 'stroke-map-region-lime',
  orange: 'stroke-map-region-orange',
  violet: 'stroke-map-region-violet',
  blue: 'stroke-map-region-blue',
  coral: 'stroke-map-region-coral',
}

/** A wash in the color, under an outline in it. */
export const REGION_FILL: Record<RegionColor, string> = {
  yellow: 'fill-map-region-yellow',
  cyan: 'fill-map-region-cyan',
  pink: 'fill-map-region-pink',
  lime: 'fill-map-region-lime',
  orange: 'fill-map-region-orange',
  violet: 'fill-map-region-violet',
  blue: 'fill-map-region-blue',
  coral: 'fill-map-region-coral',
}

/** A badge's edge, or a chip's dot, in the color. */
export const REGION_BORDER: Record<RegionColor, string> = {
  yellow: 'border-map-region-yellow',
  cyan: 'border-map-region-cyan',
  pink: 'border-map-region-pink',
  lime: 'border-map-region-lime',
  orange: 'border-map-region-orange',
  violet: 'border-map-region-violet',
  blue: 'border-map-region-blue',
  coral: 'border-map-region-coral',
}

export const REGION_BG: Record<RegionColor, string> = {
  yellow: 'bg-map-region-yellow',
  cyan: 'bg-map-region-cyan',
  pink: 'bg-map-region-pink',
  lime: 'bg-map-region-lime',
  orange: 'bg-map-region-orange',
  violet: 'bg-map-region-violet',
  blue: 'bg-map-region-blue',
  coral: 'bg-map-region-coral',
}
